"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactNativeWeb = require("react-native-web");

var _AaPlatform = _interopRequireDefault(require("./AaPlatform"));

var METHODS = {
  get: 'getItem',
  set: 'setItem',
  remove: 'removeItem'
};

var createStorageMethod = function createStorageMethod(method) {
  return function (key) {
    for (var _len = arguments.length, restArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      restArgs[_key - 1] = arguments[_key];
    }

    if (_AaPlatform["default"].IS_WEB) {
      var _localStorage;

      return Promise.resolve((_localStorage = localStorage)[method].apply(_localStorage, [key].concat(restArgs)));
    }

    return _reactNativeWeb.AsyncStorage[method].apply(_reactNativeWeb.AsyncStorage, [key].concat(restArgs));
  };
};

var getItem = createStorageMethod(METHODS.get);
var setItem = createStorageMethod(METHODS.set);
var removeItem = createStorageMethod(METHODS.remove);
var _default = {
  getItem: getItem,
  setItem: setItem,
  removeItem: removeItem
};
exports["default"] = _default;